import { FlashMessage } from '@app/src/common/FlashMessage';
import { SIZE } from '@app/src/ui';
import styled from 'styled-components';

export const FlashMessageWrapper = styled(FlashMessage)`
  bottom: 0;
  width: 100%;
  padding: 15px;
  margin-top: -40px;
  position: relative;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    padding: 15px 0;
  }
`;